import classNames from 'classnames';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { InfoIcon } from 'src/components/Icons/Info';
import { InitialCommonStateType, showModal } from 'src/store/commonPart/slice';

type Props = Omit<InitialCommonStateType['modal'][0], 'id'> & {
  children?: string;
  withWrapper?: boolean;
  className?: string;
  tag?: 'div';
};

export const UiInfoModalIcon: React.FC<Props> = memo(({ withWrapper, children, className, tag, ...props }: Props) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const onShowModal = useCallback(() => {
    dispatch(
      showModal({
        buttonFooter: {
          successBtnText: t('common.justCloseModal'),
          onlySuccessBtn: true,
        },
        ...props,
      })
    );
  }, [dispatch, props, t]);

  const Tag = tag || 'p';

  return (
    <Tag
      role="presentation"
      className={classNames('modal_icon', className, {
        'text-center': withWrapper,
      })}
    >
      {children}
      <span role="presentation" onClick={onShowModal}>
        <InfoIcon className="BrandClass default-class" />
      </span>
    </Tag>
  );
});
